export default __webpack_public_path__ + "static/media/nestable_icon.562ff1cd.svg";